import { Dispatch, ReactElement, ReactNode } from 'react';
import { ICustomHeaderProps } from '../../components/Layout/Header';
import { ActionMap } from '../../API/GoMoto.types';

// TODO: Finish commenting the types here.

export enum Types {
    ShowKioskBackground = 'SHOW_KIOSK_BACKGROUND',
    HideKioskBackground = 'HIDE_KIOSK_BACKGROUND',
    SetKioskBackgroundVisibility = 'SET_KIOSK_BACKGROUND_VISIBILITY',
    HideIdleTimeoutDialog = 'HIDE_IDLE_TIMEOUT_DIALOG',
    SetEvokeOnStillActive = 'SET_EVOKE_ON_STILL_ACTIVE',
    SetEvokeOnTimeout = 'SET_EVOKE_ON_TIMEOUT',
    SetKioskBannerVisibility = 'SET_KIOSK_BANNER_VISIBILITY',
    SetHeaderProps = 'SET_HEADER_PROPS',
    UpdateState = 'UPDATE_STATE'
}

export type EvokeOnStillActiveFunction = () => void;
export type EvokeOnStillActive = EvokeOnStillActiveFunction | undefined;
export type EvokeOnTimeoutFunction = () => boolean;
export type EvokeOnTimeout = EvokeOnTimeoutFunction | undefined;
export type HeaderProps = ICustomHeaderProps | null | undefined;

export type PageState = PageInitialState | undefined;
export type PageDispatch = Dispatch<PageActions> | undefined;

export type PagePayload = {
    [Types.ShowKioskBackground]: never;
    [Types.HideKioskBackground]: never;
    [Types.SetKioskBackgroundVisibility]: boolean;
    [Types.HideIdleTimeoutDialog]: boolean;
    [Types.SetEvokeOnStillActive]: EvokeOnStillActive | undefined;
    [Types.SetEvokeOnTimeout]: EvokeOnTimeout | undefined;
    [Types.SetKioskBannerVisibility]: boolean;
    [Types.SetHeaderProps]: HeaderProps | undefined;
    [Types.UpdateState]: PageProviderProps;
};

export type PageActions = ActionMap<PagePayload>[keyof ActionMap<PagePayload>];

export type PageReducerFunction = (state: PageInitialState, action: PageActions) => PageInitialState;

export type PageInitialState = {
    showKioskBackground: boolean;
    hideIdleTimeoutDialog: boolean;
    evokeOnStillActive: EvokeOnStillActive;
    evokeOnTimeout: EvokeOnTimeout;
    showKioskBanner: boolean;
    headerProps: HeaderProps;
};

export interface PageProviderProps {
    showKioskBackground?: boolean;
    showKioskBanner?: boolean;
    headerProps?: ICustomHeaderProps | null;
    suppressTimeout?: boolean;
    children?: ReactNode;
}

export type PageProviderComponent = (props: PageProviderProps) => ReactElement;
export type UsePageStateFunction = () => PageInitialState;
export type UsePageDispatchFunction = () => Dispatch<PageActions>;
export type UseShowKioskBackgroundFunction = () => () => void;
export type UseHideKioskBackgroundFunction = () => () => void;
export type UseSetKioskBackgroundVisibilityFunction = () => (visibility: boolean) => void;
export type UseSetKioskBannerVisibilityFunction = () => (visibility: boolean) => void;
export type UseSetHeaderPropsFunction = () => (headerProps: HeaderProps | undefined) => void;